/**
 * @type {Object<string, LetsMessage>}
 */
const LetsMessageMap ={
  MSG_0001:{
    message: '操作エラー: 他の端末によって更新されました。画面を再表示して最新の情報を取得してください。',
    messageType: '正常',
  },
  MSG_1001:{
    message: '更新しました。',
    messageType: '正常',
  },
  MSG_1002:{
    message: '削除しました。',
    messageType: '正常',
  },
  MSG_1003:{
    message: 'スケジュールが重複するためスケジュールを更新できません。\n｛$errorMessage｝\n 画面を再表示して最新の情報を取得してください。',
    messageType: 'エラー',
  },
  MSG_1004:{
    message: '講師シフトが勤務不可に更新されたためスケジュールを更新できません。\n｛$errorMessage｝\n画面を再表示して最新の情報を取得してください。',
    messageType: 'エラー',
  },
  MSG_1005:{
    message: '｛$scheduleDate｝の自動割当をリセットします。よろしいですか？',
    messageType: '確認',
  },
  MSG_1006:{
    message: '｛$scheduleDate｝の割当解除を実施します。\n 自動割当、手動割当のすべてが解除されます。よろしいですか？',
    messageType: '確認',
  },
  MSG_1007:{
    message: '｛$scheduleDate｝の自動割当が終了しました。\n「表示更新」ボタンを押して最新の情報を取得してください。',
    messageType: '正常',
  },
  MSG_1008:{
    message: '｛$scheduleDate｝の自動解除が終了しました。\n「表示更新」ボタンを押して最新の情報を取得してください。',
    messageType: '正常',
  },
  MSG_1009:{
    message: '自動割当の処理でエラーが発生しました。',
    messageType: 'エラー',
  },
}

class LetsMessage {
  messageId = '';
  message = 'Empty message';
  /**
   * @type {'error' | 'confirm' | 'normal'}
   */
  messageType = 'normal';
  /**
   * @param {Vue} ctx
   * @param {Object<string, string>} data
   * @returns {Promise<any>}
   */
  render(ctx, data=null) {
    let message = this.message;
    if (data) {
      for (const key in data) {
        message = message.replace(`｛$${key}｝`, data[key]);
      }
    }

    if (this.messageType === 'error') {
      return ctx.$dialog.notify.error(message);
    } else if (this.messageType === 'confirm') {
      return ctx.$confirm({
        text: message,
        title: '確認',
        persistent: true,
        actions: [
          { key: true, text: 'はい', color: 'primary' },
          { key: false, text: 'いいえ' },
        ]
      })
    } else {
      return ctx.$dialog.notify.info(message);
    }
  }
}

const messageTypes = {
  エラー: 'error',
  確認: 'confirm',
  正常: 'normal',
};


for (const key in LetsMessageMap) {
  LetsMessageMap[key].messageId = key;
  LetsMessageMap[key].messageType = messageTypes[LetsMessageMap[key].messageType];
  LetsMessageMap[key] = Object.assign(new LetsMessage(), LetsMessageMap[key]);
}

export {
  LetsMessageMap
}
